import { put, post, get, del } from "@utils/axios";

const api = "user-management/roles";

export const getRolesReq = () => {
  return get(`${api}`);
}

export const createRoleReq = (payload) => {
  return post(`${api}`, payload);
}

export const deleteRoleReq = (id) => {
  return del(`${api}/${id}`);
}

export const updateRoleReq = (payload) => {
  return put(`${api}/${payload.object.id}`, payload);
}

export const changeStatusReq = (payload) => {
  return post(`${api}-status`, payload);
}

export const getRolePermissionsReq = (id) => {
  return get(`user-management/role-permissions/${id}`);
}

export const getRolesPermissionReq = () => {
  return get(`/module-permissions`);
}

export const storePermissionsReq = (payload) => {
  return post(`/user-management/role-permissions`, payload);
}